// extracted by mini-css-extract-plugin
module.exports = {"textStyle":"section-header-text-module--textStyle--2O-SE","divStyle":"section-header-text-module--divStyle--36eoQ"};